var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.MapTileLayerGroup = new Class({
    Extends: OCS.Viewer.Classes.LayerGroup,
    options: {
        mapUsername: '',
        mapStyleName: '',
        mapApiKey: '',
        layer_source_ops: {
            init: {
                url: "https://api.mapbox.com/styles/v1/{mapUsername}/{mapStyleName}/tiles/256/{z}/{x}/{y}?access_token={mapApiKey}"
            }
        }
    },
    initialize: function (op) {
        this.parent(op);
        if(this.options.mapUsername && this.options.mapStyleName, this.options.mapApiKey) {
            this.options.layer_source_ops.init.url = this.options.layer_source_ops.init.url.replace('{mapUsername}', this.options.mapUsername).replace('{mapStyleName}', this.options.mapStyleName).replace('{mapApiKey}', this.options.mapApiKey);
        } else {
            // Clear the url, set the visibility to off and fire off the alert
            this.options.layer_source_ops.init.url = "";
            this.set_visible(false);
            console.error('MapTileLayerGroup: Map settings not set correctly. No map will be rendered!');
            //alert("Map not correctly configured! Please contact operator@mesonet.org for help.");
        }
    },
    get_layer_name: function () {
        return "Roads";
    },
    get_layer_short_name: function () {
        return "Roads";
    }
});


